



















































































import Vue from 'vue';

import Draggable from 'vuedraggable';
import { VBTooltip } from 'bootstrap-vue';
import DragIcon from '@/pages/settings/custom_attributes/configuration/layout/DragIcon.vue';

export default Vue.extend({
  name: 'ColumnReorder',
  components: {
    Draggable,
    DragIcon,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  model: {
    prop: 'activeColumns',
    event: 'columnChange',
  },
  props: {
    allColumns: {
      type: Array,
      required: true,
    },
    activeColumns: {
      type: Array,
      required: true,
    },
    highlightMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dragging: false,
    };
  },
  computed: {
    activeCols() {
      return this.activeColumns.map(c => this.allColumns.find(d => d.name === c));
    },
    otherCols() {
      return this.allColumns.filter(col => !this.activeColumns.includes(col.name));
    },
  },
  methods: {
    getStyle(col) {
      return col.mandatory ? 'mandatory text-truncate' : 'text-truncate';
    },
    changeHandler(cols) {
      this.$emit(
        'columnChange',
        cols.map(c => c.name)
      );
    },
    onInput(cols) {
      this.changeHandler(cols);
    },
    showCol(col) {
      // Move disabled column to first position in activeColumns
      if (col.disabled) {
        return this.changeHandler([col, ...this.activeCols]);
      }

      this.changeHandler([...this.activeCols, col]);
    },
    hideCol(col) {
      if (col.disabled) {
        return;
      }
      this.changeHandler(this.activeCols.filter(c => c.name !== col.name));
    },
    itemClass(col) {
      return {
        'col-item': true,
        'col-active': this.activeColumns.includes(col.name),
        'col-highlight': col.highlight,
        'col-disabled': col.disabled,
      };
    },
    moveHandler({ draggedContext, relatedContext }) {
      if (draggedContext.element.disabled || relatedContext.element.disabled) {
        return false;
      }
    },
  },
});
